module.exports = __webpack_public_path__ + "img/defrost-open.4a82fe55.svg";